import React from 'react';
import {
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { Space, Tag, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CourseTopicTable } from '@/domains/course-topic/entities';

interface TableProps {
  onSelectItem: (id: string) => void;
  onRemoveItem?: (id: string) => void;
}

const TableColumn = ({ onSelectItem, onRemoveItem }: TableProps) => {
  const columns: ColumnsType<CourseTopicTable> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },

    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <>
          {isActive ? (
            <Tag icon={<CheckCircleOutlined />} color='success'>
              Active
            </Tag>
          ) : (
            <Tag icon={<CloseCircleOutlined />} color='error'>
              Inactive
            </Tag>
          )}
        </>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Tooltip title='Edit'>
            <EditOutlined
              className='text-primary'
              onClick={() => onSelectItem(record.id)}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
          {onRemoveItem && (
            <Tooltip title='Delete'>
              <DeleteOutlined
                className='text-danger'
                onClick={() => onRemoveItem(record.id)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  return columns;
};

export default TableColumn;
